import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { InstitutionTitleComponent } from '../institution-title/institution-title.component';

@Component({
  selector: 'aaos-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
